export default "__VITE_ASSET__DiGDaj$A__"